import { NgModule } from '@angular/core';

import { MasterConsultaClientesActions } from './master-consulta-clientes.actions';

@NgModule({
  providers: [
    MasterConsultaClientesActions
  ]
})
export class MasterConsultaClientesActionsModule {}
